import { Page } from '../../models/page';
import * as searchActions from './actions';
import { APIScenarioReturn } from '../../../general/apiSagaFactory';
import { api } from '../../../general/apiScenarios';
import { pagePathChanged } from '../../../general/modules/router/actions';
import { ListenerApiLight, _select, lm } from '../../listenerMiddleware';
import { logger } from '../../logger';
import { loadBreadcrumbs } from '../breadcrumbs/listeners';
import { SearchINode, SearchParams } from './model';

export function searchListeners() {
  watchSearchQueryChanged();
  watchPagePathChanged();
}

function watchSearchQueryChanged() {
  lm.takeLatest(pagePathChanged, async function (action, lapi) {
    if (!action.payload.hubSearchPageParams) {
      return;
    }
    const pl = action.payload.hubSearchPageParams;
    lapi.dispatch(searchActions.searchTextChanged({ text: pl.query }));
    lapi.dispatch(searchActions.loadSearchRequested(pl));
    // TODO: node id changed, page path changed, see other TODOs with this text
    await loadBreadcrumbs(lapi, pl.scope);
  });
}

export async function loadSearch(lapi: ListenerApiLight, searchParams: SearchParams) {
  function submitResults(nodes: SearchINode[], result: APIScenarioReturn) {
    if (lapi.signal.aborted) return;
    if (result.success) {
      lapi.dispatch(searchActions.loadSearchSuccess({ nodes }));
    } else {
      lapi.dispatch(searchActions.loadSearchError({ error: result.reason }));
    }
  }

  lapi.dispatch(searchActions.loadSearchStarted());
  const effectiveScope = searchParams.global ? null : searchParams.scope;

  if (effectiveScope === 'trash') {
    const result = await api.search.searchInTrash(searchParams.query);
    const nodes = result.success ? result.data.response.nodes : [];
    submitResults(nodes, result);
    return;
  }
  // AI-режим проверяем до тегов: на бэкенде семантический поиск с тегами не комбинируется
  // (`search-by-tag` — отдельный эндпоинт), поэтому AI имеет приоритет.
  if (!searchParams.ai && searchParams.tags.length > 0) {
    const result = await api.search.searchByTag(searchParams.tags, effectiveScope);
    logger.lapi(lapi, {
      action: 'Search',
      sub_action: 'By Tags',
      // extra: { tag_ids: searchParams.tags, scope: effectiveScope },
    });
    const nodes = result.success ? result.data.response.nodes : [];
    submitResults(nodes, result);
    return;
  }
  const result = await api.search.search(searchParams.query, effectiveScope, searchParams.ai);
  logger.lapi(lapi, {
    action: 'Search',
    sub_action: 'By Filename',
    extra: {
      text_1: searchParams.query,
      bool_1: searchParams.ai,
      //scope: effectiveScope
    },
  });
  const nodes = result.success ? result.data.response.results.nodes : [];
  submitResults(nodes, result);
}

function watchPagePathChanged() {
  lm.takeLatest(pagePathChanged, async (action, lapi) => {
    if (action.payload.page === Page.SEARCH) {
      const tags = await api.tags.load();
      if (lapi.signal.aborted) return;
      if (tags.success) {
        lapi.dispatch(searchActions.tagsUpdated({ tags: tags.data.response }));
      }
    }
  });
}
